import React, { useContext } from 'react';
import { FormContext } from '../Form';
import { FormField } from '../FormField';
import { TextArea } from './TextArea';

export const textAreaFieldTestId = 'text-area-field';

type TextAreaFieldProps = {
  name: string;
  label: string | null;
  expandable?: boolean;
};

export const TextAreaField = (props: TextAreaFieldProps) => {
  const formIsDisabled = useContext(FormContext).isDisabled;

  return (
    <FormField name={props.name} label={props.label}>
      {({ field, form, $isValid, $isInvalid }) => (
        <TextArea
          {...field}
          $isValid={$isValid}
          $isInvalid={$isInvalid}
          data-testid={textAreaFieldTestId}
          disabled={form.isSubmitting || formIsDisabled}
          expandable={props.expandable ?? false}
        />
      )}
    </FormField>
  );
};
